import React from "react";

interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: "primary" | "outline" | "white" | "ghost-dark";
  size?: "md" | "lg";
  className?: string;
  icon?: React.ReactNode;
  testId?: string;
  newTab?: boolean;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const variants: Record<string, string> = {
  primary:
    "bg-motor-red text-white hover:bg-motor-red-dark shadow-[0_10px_30px_-8px_rgba(200,16,46,0.55)]",
  outline:
    "bg-transparent text-motor-ink border-2 border-motor-ink hover:bg-motor-ink hover:text-white",
  white: "bg-white text-motor-ink hover:bg-motor-mist",
  "ghost-dark":
    "bg-white/10 text-white border border-white/30 hover:bg-white/20 backdrop-blur-sm",
};

const sizes: Record<string, string> = {
  md: "px-6 py-3.5 text-sm",
  lg: "px-8 py-4.5 text-base",
};

export const CtaButton: React.FC<CtaButtonProps> = ({
  href,
  children,
  variant = "primary",
  size = "md",
  className = "",
  icon,
  testId,
  newTab = true,
  onClick,
}) => {
  return (
    <a
      href={href}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noopener noreferrer" : undefined}
      data-testid={testId}
      onClick={onClick}
      className={`group inline-flex items-center justify-center gap-2 rounded-full font-display font-semibold uppercase tracking-wide transition-all duration-300 active:scale-[0.97] ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
      {icon}
    </a>
  );
};
